import { defineNuxtPlugin } from '#app'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

export default defineNuxtPlugin((nuxtApp) => {
  if (!nuxtApp.$pinia && import.meta.client) { // تحقق من أن Pinia غير مسجلة مسبقًا
    const pinia = createPinia()
    pinia.use(piniaPluginPersistedstate) // دعم التخزين المستمر
    nuxtApp.vueApp.use(pinia)
    nuxtApp.provide('pinia', pinia)
  }
})
